import UserModel from "./UserModel";
import TutorModel from "./TutorModel";

export default class LiaisonModel extends UserModel {
  phone_number?: string;
  full_name?: string;

  constructor(arg: any) {
    super(arg);
    this.phone_number = arg.phone_number;
    this.full_name = arg.full_name;
  }
}
